import FormImageCropper from 'components/form/FormImageCropper';
import FormSelect from 'components/form/FormSelect';
import FormText from 'components/form/FormText';

import type { FieldErrors, UseFormRegister } from 'react-hook-form';
import type { SignupOldCompanyFormStateType } from '../SignupOldCompany';
import { getCompanyImageUrl, getDivSelectOptions } from 'utils/app';

import type { JSX } from 'react';

type ImageCropperState = {
  isOpen: boolean;
  setIsOpen: (v: boolean) => void;
  isReset: boolean;
  setIsReset: (v: boolean) => void;
  imageBlob: Blob | null;
  setImageBlob: (v: Blob | null) => void;
  openCropper: () => void;
  resetCropper: () => void;
};

export function SignupOldCompanyInfoSection({
  register,
  errors,
  imageCropper,
}: {
  register: UseFormRegister<SignupOldCompanyFormStateType>;
  errors: FieldErrors<SignupOldCompanyFormStateType>;
  imageCropper: ImageCropperState;
}): JSX.Element {
  return (
    <>
      <div className="form-about-us">
        <div className="d-md-flex d-flex-header">
          <div className="flex-shrink-0 flex-left mb-3">
            <h3 className="title-section title-md fw-bold">会社情報</h3>
          </div>
        </div>{' '}
        <div className="d-flex justify-content-start align-items-center">
          <div className="flex-shrink-0 flex-img me-4">
            <FormImageCropper
              isOpen={imageCropper.isOpen}
              setIsOpen={imageCropper.setIsOpen}
              isReset={imageCropper.isReset}
              setIsReset={imageCropper.setIsReset}
              imageUrl={getCompanyImageUrl(null)}
              imageUrlDefault={getCompanyImageUrl(null)}
              cropWidth={256}
              cropRatio={1}
              displayWidth={80}
              setImageBlob={imageCropper.setImageBlob}
            />
          </div>
          <div className="flex-grow-1 flex-text mb-0 ps-1">
            <a onClick={imageCropper.openCropper} className="mb-2">
              画像アップロード
            </a>
            <br />
            <a onClick={imageCropper.resetCropper}>削除</a>
          </div>
        </div>
      </div>

      <div className="form-group">
        <div className="row form-row flex-md-row justify-content-between">
          <div className="column col-lg-6 col-xl-6 col-left">
            <FormText
              subject="法人名"
              name="companyName"
              placeholder="株式会社サンプル"
              register={register}
              errors={errors}
              required={true}
              maxLength={100}
              requiredMark={true}
            />
          </div>
          <div className="column col-lg-6 col-xl-6 col-right">
            <FormText
              subject="電話番号"
              name="companyTel"
              placeholder="1234567890"
              register={register}
              errors={errors}
              required={true}
              maxLength={50}
              format="numeric"
              requiredMark={true}
            />
          </div>
        </div>
        <div className="row form-row flex-md-row justify-content-between">
          <div className="column col-lg-6 col-xl-6 col-left">
            <FormText
              subject="郵便番号"
              name="zipCode"
              placeholder="1000001"
              register={register}
              errors={errors}
              required={true}
              maxLength={7}
              minLength={7}
              format="numeric"
              requiredMark={true}
            />
          </div>
          <div className="column col-lg-6 col-xl-6 col-right">
            <FormSelect
              subject="都道府県"
              name="prefectureDiv"
              register={register}
              errors={errors}
              options={getDivSelectOptions('prefecture')}
              required={true}
              blank={true}
              blankLabel="選択してください"
              requiredMark={true}
            />
          </div>
        </div>
        <div className="row form-row flex-md-row justify-content-between">
          <div className="column col-lg-6 col-xl-6 col-left">
            <FormText
              subject="市区町村"
              name="city"
              placeholder="千代田区"
              register={register}
              errors={errors}
              required={true}
              maxLength={100}
              requiredMark={true}
            />
          </div>
          <div className="column col-lg-6 col-xl-6 col-right">
            <FormText
              subject="番地以降"
              name="address"
              placeholder="丸の内1-1-1"
              register={register}
              errors={errors}
              required={true}
              maxLength={100}
              requiredMark={true}
            />
          </div>
        </div>
        <div className="row form-row flex-md-row justify-content-between">
          <div className="column col-lg-6 col-xl-6 col-left">
            <FormText
              subject="建物名・部屋番号"
              name="buildingName"
              placeholder="サンプルビル1F"
              register={register}
              errors={errors}
              maxLength={100}
              requiredMark={true}
            />
          </div>
          <div className="column col-lg-6 col-xl-6 col-right"></div>
        </div>
      </div>

      <div className="form-group">
        <div className="row form-row flex-md-row justify-content-between">
          <div className="column col-lg-6 col-xl-6 col-left">
            <FormText
              subject="プライバシーポリシーのURL"
              name="privacyPolicyUrl"
              placeholder="http://example.com/plivacypolicy"
              register={register}
              errors={errors}
              maxLength={100}
              requiredMark={true}
              format="url"
              required={true}
            />
            <p className="mt-1">プライバシーポリシーが記載されたページのURLを記入してください</p>
          </div>
          <div className="column col-lg-6 col-xl-6 col-right">
            <FormText
              subject="コピーライトの設定"
              name="copyright"
              placeholder="©株式会社サンプル"
              register={register}
              errors={errors}
              maxLength={100}
              required={true}
              requiredMark={true}
            />
          </div>
        </div>
      </div>
    </>
  );
}
